import script from "./AvatarPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarPicker.vue?vue&type=script&setup=true&lang=js"

import "./AvatarPicker.vue?vue&type=style&index=0&id=e14f7e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e14f7e16"]])

export default __exports__